import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, isNotEmpty } from 'class-validator';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class PostActivityDTO {
  @ApiProperty()
  @IsOptional()
  Id?: number;
  @ApiProperty()
  @IsNotEmpty({message:"Post id should not be empty"})
  postId:number;
  @ApiProperty()
  @IsNotEmpty({message:"User id should not be empty"})
  userId:number;
  @ApiProperty({
    description: 'if post like cliked - type: boolean',
    default:null
  })
  @ApiPropertyOptional()
  like?:boolean;
  @ApiProperty({
    description: 'if post dislike cliked - type: boolean',
    default:null
  })
  @ApiPropertyOptional()
  dislike?:boolean;
  @ApiProperty({
    description: 'if post fev cliked - type: boolean',
    default:null
  })
  @ApiPropertyOptional()
  fev?: boolean;
  @ApiProperty({
    description: 'if post shared cliked - type: integer',
    default:0
  })
  @IsOptional()
  @ApiPropertyOptional()
  shared:number;
  @ApiProperty()
  status: boolean;
  createdAt : Date;
  @ApiProperty()
  @IsOptional()
  createdUser : number;
  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @ApiPropertyOptional()
  updatedUser : number;
  @ApiProperty({
    description: 'api version number - type: integer',
    minimum:1,
    default:1
  })
  versionFlag : number;
}
